import { PropsWithChildren, ReactElement } from "react";
import classNames from "classnames";

import { VerticalSpace } from "components/VerticalSpace/VerticalSpace";
import { Divider } from "components/Divider/Divider";

import styles from "./styles.module.scss";

export type BaseLayoutProps = PropsWithChildren<{
  minHeight?: number;
  maxHeight?: number;
  header: ReactElement;
  footer: ReactElement;
  className?: string;
  paddings?: [number, number];
  height?: number;
  width?: number;
}>;

export const BaseLayout = (props: BaseLayoutProps): JSX.Element => {
  const style = {
    width: props.width || undefined,
    height: props.height || undefined,
  };

  return (
    <div
      style={style}
      className={classNames(
        styles.root,
        "shadow-lg rounded-md p-4",
        props.className
      )}
    >
      <div>
        {props.header}
        <VerticalSpace size={15} />
        <Divider />
      </div>
      <div
        style={{
          padding: props.paddings
            ? `${props.paddings[0]}px ${props.paddings[1]}px`
            : 0,
        }}
        className={styles.settingsBody}
      >
        {props.children}
      </div>
      <div>
        <Divider />
        <VerticalSpace size={20} />
        {props.footer}
      </div>
    </div>
  );
};
